export default __webpack_public_path__ + "refresh.a408db60ce85f7d7.svg";